import React from "react";
import { defaultSiteId } from "../constants/defaultSiteId";


export const SiteIdContext = React.createContext({
  // initialSiteId: (window && window.businessProfileId?.toString()) || defaultSiteId,
  initialSiteId: defaultSiteId,
});
